import style from "../FriendsPosts.module.css";
import React from "react";

const FriendsPost = (props) => {
    return (
        <div className={style.postCard}>
            <div className={style.cardTop}>
                <img className={style.avatarImg} src={props.imgURL} alt="avatar_img"/>
                <div className={style.friendInfo}>
                    <a href="#" className={style.friendName}>{props.name}:</a>
                    <p className={style.published}><span>Published:</span>{props.published}</p>
                </div>
            </div>
            <div className={style.cardBottom}>

                <p className={style.postMessage}>{props.message}</p>
                <p>{props.video}</p>
                <img className={style.postImg} src={props.imgRandom} alt="post_picture"/>

                <div className={style.likeBtnContainer}>
                <p>Likes: {props.likeCount}</p>
                <button className={style.likeBtn}>
                    <i className="fa-regular fa-thumbs-up"></i>
                </button>
                <button className={style.dislikeBtn}>
                    <i className="fa-regular fa-thumbs-down"></i>
                </button>
                <button className={style.pinPostBtn}>
                    <i className="fa-solid fa-thumbtack"></i>
                </button>
                </div>
            </div>

        </div>
    )
}

export default FriendsPost;